import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, ɵgetDOM } from '@angular/common';

import '@angular/common/locales/global/et';

import { AppRoutingModule } from './app-routing.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateModule } from '@angular/material/core';

import { TRANSLATION_MODULES } from './transloco-root.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule, BUCKET } from '@angular/fire/compat/storage';
import { AngularFireFunctionsModule, REGION, USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions';
import { serverTimestamp } from 'firebase/firestore';
import 'firebase/storage';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BookingModule } from './booking/booking.module';
import { AppComponent } from './app.component';
import { dateFormats, LocaleParsingDateAdapter } from './util/dates';
import { FbDocument } from './data/FbDocument';
import { ToolbarModule } from './toolbar/toolbar.module';
import { PagesModule } from './pages/pages.module';
import { AdminModule } from './admin/admin.module';

const currentLocale = 'et';

FbDocument.firebaseAccess = {
  serverTimestamp
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    MatDatepickerModule,
    NativeDateModule,
    SharedModule,
    ToolbarModule,
    BookingModule,
    PagesModule,
    AdminModule,
    MatButtonModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule
  ],
  providers: [
    provideClientHydration(),
    {
      provide: LOCALE_ID,
      useValue: currentLocale
    },
    {
      provide: TRANSLATION_MODULES,
      useValue: ['header', 'footer', 'main', 'booking', 'component-calendar', 'common']
    },
    {
      provide: DateAdapter, useClass: LocaleParsingDateAdapter
    },
    { provide: MAT_DATE_FORMATS, useValue: dateFormats },
    { provide: BUCKET, useValue: environment.firebase.storageBucket },
    {
      provide: USE_FUNCTIONS_EMULATOR,
      useValue: (environment as any).useFunctionsEmulator ? [environment.functionsHost, environment.functionsPort] : undefined
    },
    {
      provide: REGION,
      useValue: environment.functionsRegion
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
